import { render, staticRenderFns } from "./DataGk.vue?vue&type=template&id=6a2c28ce&scoped=true&"
import script from "./DataGk.vue?vue&type=script&lang=js&"
export * from "./DataGk.vue?vue&type=script&lang=js&"
import style0 from "./DataGk.vue?vue&type=style&index=0&lang=less&"
import style1 from "./DataGk.vue?vue&type=style&index=1&id=6a2c28ce&lang=less&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2c28ce",
  null
  
)

export default component.exports